

export const WETH = '0x5545153ccfca01fbd7dd11c0b23ba694d9509a6f'
export const EDCAddress = "0x68a0a1fef18dfcc422db8be6f0f486dea1999edc"
export const EDCPOOLTOTAL = "0x85202D7F76Fb1708A2E7483Fe16B428eC60aef06"

export const ADDRESS_ZERO = '0x0000000000000000000000000000000000000000'
